import { Component, OnInit } from "@angular/core";
import { Router, ActivatedRoute } from "@angular/router";
import { ToastService } from "ng-uikit-pro-standard";
import { DataService } from "src/app/data.service";

@Component({
  selector: "app-metafielddependencieslist",
  templateUrl: "./metafielddependencieslist.component.html",
  styleUrls: ["./metafielddependencieslist.component.scss"],
})
export class MetafielddependencieslistComponent implements OnInit {
  displayedColumns: string[] = [
    "action",
    "controllingfield",
    "dependentfield",
    "modifiedby",
    "modifieddate",
  ];
  // dataSource = "";
  dataSource: any[] = [];

  mode: any;
  metaobjectId: any;
  metaobjectName: any;
  isLoading: boolean;
  errorMessage: any;
  isError: boolean;
  fielddependency: any;

  constructor(
    private router: Router,
    private route: ActivatedRoute,
    private toastrService: ToastService,
    private dataService: DataService
  ) {}

  ngOnInit() {
    this.route.queryParams.subscribe((params) => {
      this.mode = this.route.snapshot.params.mode;
      this.metaobjectId = this.route.snapshot.params.metaobjectid;
      this.metaobjectName = this.route.snapshot.params.metaobjectname;
    });

    this.getFieldDependency();
  }

  showSuccess(data: any) {
    let options = {
      enableHtml: true,
      positionClass: "md-toast-top-right",
      timeOut: 3000,
    };
    this.toastrService.success(data, "", options);
  }
  showError(data: any) {
    let options = { enableHtml: true, positionClass: "md-toast-bottom-right" };
    this.toastrService.error(data, "Application Error!", options);
  }

  showWarning(data: any) {
    let options = {
      enableHtml: true,
      positionClass: "md-toast-bottom-right",
      messageClass: "orange darken-4",
      toastClass: "warning-color-dark",
    };
    this.toastrService.warning(data, "", options);
  }

  new() {
    console.log("New");
    this.router.navigateByUrl(
      "/home/fielddependencies/new/" +
        this.metaobjectId +
        "/" +
        this.metaobjectName
    );
  }

  editApp(element: any) {
    this.router.navigateByUrl(
      "/home/fielddependencies/edit/" +
        element.id +
        "/" +
        element.metaobjectid +
        "/" +
        element.metaobjectname
    );
  }
  cancel() {

      this.router.navigateByUrl(
      "/home/metaobjectdetail/" +
        this.metaobjectId +
        "/" +
        this.metaobjectName 
    );
  }

  getFieldDependency() {
    return new Promise((resolve, reject) => {
      console.log("getFieldDependency");

      // alert(id)
      const organizationid = localStorage.getItem("crm_orgid");
      // const domain = localStorage.getItem("domain");
      // const subdomain = localStorage.getItem("subdomain");
      const domain = localStorage.getItem(
        `${localStorage.getItem("crm_orgid")}.domain`
      );
      const subdomain = localStorage.getItem(
        `${localStorage.getItem("crm_orgid")}.subdomain`
      );
      
      this.isLoading = true;
      this.dataService
        .getAllFieldDependency(domain, subdomain, organizationid,this.metaobjectId)
        .subscribe(
          (res) => {
            console.log("res", res);

            if (res.success == 1) {
              this.fielddependency = res.data.metafielddependency;
              console.log("Doneeee****", this.fielddependency);

              if (this.fielddependency != null) {
                this.dataSource = this.fielddependency.map((item) => ({
                  id: item.id,
                  controllingfield: item.controllingfieldname,
                  dependentfield: item.dependentfieldname,
                  metaobjectname: item.metaobjectname,
                  metaobjectid: item.metaobjectid,
                  modifiedby: item.modifiedby,
                  modifieddate: item.modifieddate,

                  // type: item.actiontype,
                  // content: item.content,
                  // metalayoutid: item.metalayoutid,
                }));
              }

              this.isLoading = false;
              resolve(res); // Successfully resolve with response data
            } else {
              console.log("Error while saving");
              this.isLoading = false;
              reject(new Error("Error while saving data")); // Reject with a custom error message
            }
          },
          (err) => {
            console.log("Error***:", err);
            this.errorMessage = err.message;
            this.isError = true;
            this.isLoading = false;
            reject(err); // Reject with the error from the observable
          }
        );
    });
  }

  delete(id: number) {
    // alert(id)
    const organizationid = localStorage.getItem("crm_orgid");
    const domain = localStorage.getItem(
      `${localStorage.getItem("crm_orgid")}.domain`
    );
    const subdomain = localStorage.getItem(
      `${localStorage.getItem("crm_orgid")}.subdomain`
    );
    const confirmDelete = window.confirm("Are you sure you want to delete?");

    if (!confirmDelete) {
      return;
    }
    this.isLoading = true;
    this.dataService
      .deleteMetafieldDependency(organizationid, id, domain, subdomain)
      .subscribe(
        (res) => {
          // alert('****res****' + JSON.stringify(res));
          console.log(res);
          if (res.success == 1) {
            // alert("Are you sure?")

            this.showSuccess(res.message);
            this.isLoading = false;

            // window.location.reload();
            // 🚀 Reload current component
            const currentUrl = this.router.url;
            this.router
              .navigateByUrl("/", { skipLocationChange: true })
              .then(() => {
                this.router.navigate([currentUrl]);
              });
          } else {
            console.log("Failed to delete!");
            this.isLoading = false;
            this.showError(res.message);
          }
        },
        (err) => {
          console.log("Error***:", err);
          this.errorMessage = err.message;
          this.isError = true;
          this.isLoading = false;
          this.showError(err.message);
        }
      );
   
  }
}
